<template>
  <div>
    <b-field v-if="!quick" :label="$t('surveyTitle')">
      <b-input v-model="title" expanded />
    </b-field>

    <b-field v-if="!quick" :label="$t('questions')" />
    <div v-for="(question, key) in questions" :key="key" class="mt-4">
      <EditQuestion
        :question-key="key"
        :question="question"
        :questions="questions"
        :quick="quick"
        :modal="false"
        :survey-id="survey.id"
      />
    </div>
    <b-button
      class="my-5"
      type="is-primary"
      :loading="isLoading"
      :disabled="isDisabled"
      @click.native="quick ? saveChanges() : addQuestion()"
    >
      {{ $t("addQuestion") }}
    </b-button>
    <b-button
      class="my-5 ml-2"
      type="is-primary"
      :loading="isLoading"
      :disabled="isDisabled"
      @click.native="quick ? changeQuestionType() : addQuestion('surveySimple')"
    >
      <span v-if="quick">
        {{ $t("changeQuestionType") }}
      </span>
      <span v-else>
        {{ $t("addYesNoQuestion") }}
      </span>
    </b-button>
  </div>
</template>

<script>
import { v4 } from "uuid";
import { functions } from "@/firebase";
import cloneDeep from "clone-deep";
import EditQuestion from "./EditQuestion";

export default {
  name: "SurveyCreatorQuestions",
  components: {
    EditQuestion,
  },
  props: {
    quick: {
      type: Boolean,
      default: false,
    },
    surveyId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isLoading: false,
      isDisabled: false,
      sampleQuestions: {
        surveySelect: {
          type: "surveySelect",
          question: "",
          options: [{ text: "" }, { text: "" }, { text: "" }],
          selectable: 1,
          closed: false,
          duration: 60,
          timed: false,
          personalization: false,
          showResults: true,
          onlyFinalResults: false,
          abstain: true,
          showAbstainBig: false,
        },
        surveySimple: {
          type: "surveySimple",
          question: "",
          options: [{ text: "Ja" }, { text: "Nein" }],
          selectable: 1,
          closed: false,
          duration: 60,
          timed: false,
          personalization: false,
          showResults: true,
          onlyFinalResults: false,
          abstain: true,
          showAbstainBig: false,
        },
        surveyStars: {
          type: "surveyStars",
          question: "Das ist eine Umfrage bei der man etwas bewerten kann",
          options: {
            rating: 0,
          },
        },
        surveyRunOff: {
          type: "surveyRunOff",
          question: "Das ist eine Stichwahl bei der die 2 besten Option nochmals zu wahl gestellt werden",
          options: [{ text: "" }, { text: "" }, { text: "" }],
          selectable: 1,
        },
      },
    };
  },
  computed: {
    questions: {
      get() {
        return this.$store.state.survey.questions;
      },
      set(value) {
        this.$store.commit("SET_SURVEY_FIELD", ["questions", value]);
      },
    },
    title: {
      get() {
        return this.$store.state.survey.title;
      },
      set(value) {
        this.$store.commit("SET_SURVEY_FIELD", ["title", value]);
        this.$emit("change");
      },
    },
    survey() {
      return this.$store.state.survey;
    },
  },
  watch: {
    questions: {
      deep: true,
      handler() {
        this.questions.changed = !this.questions.changed || false;
        this.$emit("change");
      },
    },
    survey() {
      if (this.quick) {
        this.addQuestion();
      }
    },
  },
  created() {
    if (this.questions.length == 0 || this.quick) {
      this.addQuestion("surveySelect", 0);
    }
  },
  methods: {
    addQuestion(questionType = "surveySelect") {
      let q = cloneDeep(this.sampleQuestions[questionType]);
      this.questions.push(q);
      this.questions[this.questions.length - 1]._sortId = v4();
    },
    async saveChanges() {
      this.isLoading = true;
      this.isDisabled = true;
      try {
        let surveyInfo = await functions.httpsCallable("CreateSurvey")({
          survey: this.$store.state.survey,
          surveyId: this.surveyId,
        });
        console.log(surveyInfo);
        this.$buefy.toast.open({
          type: "is-success",
          message: this.$t("surveySaved"),
        });
      } catch (error) {
        this.$buefy.toast.open({
          type: "is-danger",
          message: this.$t(error),
        });
      } finally {
        this.isLoading = false;
        this.isDisabled = false;
      }
    },
    // really weird function that only plays a role with quickly adding another ´question
    // the last question is the new question so this function changes the last index of the quetsions array to a different question type
    changeQuestionType() {
      let lastQuestion = this.questions[this.questions.length - 1];
      let newType = "surveySelect";
      if (lastQuestion.type == "surveySelect") {
        newType = "surveySimple";
      }
      this.removeQuestion(this.questions.length - 1);
      this.addQuestion(newType);
    },
  },
};
</script>

<style></style>
